import { useState } from 'react'
import * as S from './index.style'
import theme from 'styles/theme'
import NumberFormat from 'react-number-format'
import Button from '@material-ui/core/Button'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import { Add } from '@styled-icons/material-rounded/Add'
import { Edit } from '@styled-icons/material-rounded/Edit'
import { Delete } from '@styled-icons/material-rounded/Delete'
import { DadosDatas } from 'models/Viabilidade/Datas'
import { DadosParcela, dadosParcelaValorDefault } from 'models/Viabilidade/Parcela'
import NovaParcela from './NovaParcela'
import { secaoOpcional } from 'helpers/Constantes/Mensagens'
import { formatarData } from 'helpers/formatador'

export type TornaProps = {
  dadosTorna: DadosParcela[]
  dadosDatas: DadosDatas
  dadosTornaHandler: (novoValor: DadosParcela[]) => void
}

const Torna: React.FC<TornaProps> = ({ dadosTorna, dadosDatas, dadosTornaHandler }) => {
  const [dialogAberto, setDialogAberto] = useState(false)
  const [dadosParcelas, setDadosParcelas] = useState(dadosTorna)
  const [parcelaEdicao, setParcelaEdicao] = useState(dadosParcelaValorDefault)
  const [indiceEdicao, setIndiceEdicao] = useState(0)

  const valorFormatado = (valor: string | number, scala = 2, prefix = '', suffix = '') => {
    const valorConvertido = parseFloat(valor.toString()).toLocaleString('pt-BR')
    return (
      <NumberFormat
        value={valorConvertido}
        decimalScale={scala}
        thousandSeparator="."
        decimalSeparator=","
        displayType={'text'}
        defaultValue="-"
        prefix={prefix}
        suffix={suffix}
        fixedDecimalScale
      />
    )
  }

  const adicionarDias = (data: Date, dias: number) => {
    const novaData = new Date(Number(data))
    novaData.setDate(novaData.getDay() + dias)
    return novaData
  }

  const adicionarParcelaDialogHandler = (novoValor: DadosParcela) => {
    const novosDadosParcela = [...dadosParcelas, novoValor]
    setDialogAberto(false)
    setDadosParcelas(novosDadosParcela)
    dadosTornaHandler(novosDadosParcela)
  }

  const editarParcelaDialogHandler = (novoValor: DadosParcela, indiceEdicao: number) => {
    const novosDadosParcela = dadosParcelas.map((value, index) => {
      if (index === indiceEdicao) {
        value = novoValor
      }
      return value
    })
    setDialogAberto(false)
    setDadosParcelas(novosDadosParcela)
    dadosTornaHandler(novosDadosParcela)
  }

  const editarParcelaHandler = (index: number) => {
    const parcelaParaEditar = dadosParcelas[index]
    setIndiceEdicao(index)
    setParcelaEdicao(parcelaParaEditar)
    setDialogAberto(true)
  }

  const deletarParcelaHandler = (indiceRemover: number) => {
    const novosDadosParcela = dadosParcelas.filter((_value, index) => index != indiceRemover)
    setDadosParcelas(novosDadosParcela)
    dadosTornaHandler(novosDadosParcela)
  }

  const abrirDialog = () => {
    setParcelaEdicao(dadosParcelaValorDefault)
    setDialogAberto(true)
  }

  const fecharDialog = () => {
    setDialogAberto(false)
  }

  const dataConsolidada = (parcela: DadosParcela) => {
    const colchao = parcela.colchaoPrimeiraParcela ? parseInt(parcela.colchaoPrimeiraParcela.toString()) : 0
    return parcela.dataBasePrimeiraParcela ? formatarData(adicionarDias(parcela.dataBasePrimeiraParcela, colchao)) : '-'
  }

  return (
    <S.Wrapper data-cy="sessaoTorna">
      <S.NomeSecao>
        Torna <S.SecaoOpcional>{secaoOpcional}</S.SecaoOpcional>
      </S.NomeSecao>
      <TableContainer component={S.BoxCustomizado}>
        <Table data-cy="tabelaParcelas">
          <TableHead>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Valor da Parcela (R$)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Nº de Parcelas
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Condicionante
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Data Base 1ª Parcela
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Colchão 1ª Parcela (dias)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Data Consolidada
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Índice Correção (%)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Cond. Data Base Correção
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Data Base Correção
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}></TableCell>
          </TableHead>
          <TableBody>
            {dadosParcelas.map((parcela: DadosParcela, index: number) => (
              <TableRow key={`parcela${index}`} data-cy={`trParcelas_${index}`}>
                <TableCell data-cy="tdValorParcela" align="center">
                  {valorFormatado(parcela.valorParcela)}
                </TableCell>
                <TableCell data-cy="tdNumeroParcela" align="center">
                  {valorFormatado(parcela.numeroParcelas, 0)}
                </TableCell>
                <TableCell data-cy="tdCondicionante" align="center">
                  {parcela.condicionante}
                </TableCell>
                <TableCell data-cy="tdDataBasePrimeiraParcela" align="center">
                  {parcela.dataBasePrimeiraParcela ? formatarData(parcela.dataBasePrimeiraParcela) : '-'}
                </TableCell>
                <TableCell data-cy="tdColchao" align="center">
                  {parcela.colchaoPrimeiraParcela ? valorFormatado(parcela.colchaoPrimeiraParcela, 0) : '-'}
                </TableCell>
                <TableCell data-cy="tdDataConsolidada" align="center">
                  {dataConsolidada(parcela)}
                </TableCell>
                <TableCell data-cy="tdIndiceCorrecao" align="center">
                  {parcela.taxaCorrecao ? valorFormatado(parcela.taxaCorrecao, 2, '', '%') : '-'}
                </TableCell>
                <TableCell data-cy="tdCondicionanteDataBaseCorrecao" align="center">
                  {parcela.condicionanteDataBaseCorrecao ? parcela.condicionanteDataBaseCorrecao : '-'}
                </TableCell>
                <TableCell data-cy="tdDataBaseCorrecao" align="center">
                  {parcela.dataBaseCorrecao ? formatarData(parcela.dataBaseCorrecao) : '-'}
                </TableCell>
                <TableCell align="center">
                  <S.GridBotoes>
                    <div>
                      <IconButton
                        color="primary"
                        data-cy="btnEditarParcela"
                        aria-label="edit"
                        onClick={() => {
                          editarParcelaHandler(index)
                        }}
                      >
                        <Edit size={24} />
                      </IconButton>
                    </div>
                    <div>
                      <IconButton
                        color="primary"
                        data-cy="btnDeletarParcela"
                        aria-label="delete"
                        onClick={() => {
                          deletarParcelaHandler(index)
                        }}
                      >
                        <Delete size={24} />
                      </IconButton>
                    </div>
                  </S.GridBotoes>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <S.GridBotao>
        <Button data-cy="btnNovaParcela" onClick={abrirDialog} variant="contained" style={{ height: '40px' }} color="secondary" startIcon={<Add size={24} />}>
          Nova Parcela
        </Button>
      </S.GridBotao>
      <Dialog open={dialogAberto} maxWidth="lg" onClose={fecharDialog} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
        <NovaParcela
          closeDialogParcelaHandler={fecharDialog}
          adicionarParcelaHandler={adicionarParcelaDialogHandler}
          editarParcelaHandler={editarParcelaDialogHandler}
          dadosDatas={dadosDatas}
          dadosParcela={parcelaEdicao}
          indiceEdicao={indiceEdicao}
        ></NovaParcela>
      </Dialog>
    </S.Wrapper>
  )
}

export default Torna
